var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({attrs:{"max-width":"400px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.showUnderline)?_c('span',_vm._g(_vm._b({staticClass:"tooltip-span"},'span',attrs,false),on),[_vm._t("default")],2):_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},"v-tooltip",_vm._d({},[_vm.position,true])),[_c('vue-markdown',{attrs:{"source":_vm.docs,"breaks":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }